// ===================================================================
// KAIXO - FollowedChannelsList
// ===================================================================
// Vista 'followedChannels': lista los canales que sigue el usuario
// (excluye los propios). Al tocar uno abre ese canal (vista chat).
// ===================================================================

import React from 'react';
import { Icons } from '../Icons/Icons';
import ct from './i18n';

export default function FollowedChannelsList({
    channels,
    currentUserId,
    loading,
    onOpenChannel
}) {
    const followed = (channels || []).filter(c => {
        const ownerId = String(c.owner?._id || c.owner || '');
        return ownerId !== String(currentUserId);
    });

    return (
        <div className="v2-body">
            {loading ? (
                <p className="v2-center">{ct.loading}</p>
            ) : followed.length === 0 ? (
                <p className="v2-center v2-dim">
                    {ct.empty || 'Aún no sigues ningún latido.'}
                </p>
            ) : followed.map(c => (
                <div
                    key={c._id}
                    className="v2-channel-item"
                    onClick={() => onOpenChannel(c)}
                >
                    <div className="v2-channel-avatar">
                        {c.avatar
                            ? <img src={c.avatar} alt="" loading="lazy" decoding="async" />
                            : c.name?.[0]}
                    </div>
                    <div className="v2-channel-info">
                        <div className="v2-channel-name">{c.name}</div>
                        <div className="v2-channel-preview">{c.status || c.description || '—'}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
